import React, { useContext, useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import { adminBaseURL } from '../../constants/API';
import { authorize } from '../../shared/authorize';
import { Language } from '../../App';

const RelatedSearches = ({ searchTerm }) => {
  const {lang} = useContext(Language);
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!searchTerm) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(adminBaseURL+'user/web/course/suggestions', {
          search: searchTerm
        },authorize());
        setSuggestions(response.data.data || response.data || []);
      } catch (err) {
        setError('Failed to fetch suggestions');
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [searchTerm]);

  return (
    <div
      className="bg-white shadow p-4 rounded w-100"
      style={{
        maxWidth: '400px',
        marginTop: '10px',
      }}
    >
      <h2 className="text-secondary text-uppercase small font-weight-semibold mb-3">
        {lang.related_searches}
      </h2>
      {loading && <p className="text-muted">Loading...</p>}
      {error && <p className="text-danger">{error}</p>}
      {!loading && !error && suggestions.length === 0 && searchTerm && (
        <p className="text-muted">No suggestions found</p>
      )}
      <ul className="list-unstyled m-0">
        {suggestions.map((item, index) => (
          <li
            key={index}
            className={`d-flex align-items-center py-2 gap-2 ${
              index < suggestions.length - 1 ? 'border-bottom' : ''
            } border-light`}
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/courses/filter', {
              state: { query: item.name || item }
            })}
          >
            <span className="d-flex align-items-center gap-2">
              <FaSearch className="text-muted" style={{ fontSize: '1rem' }} />
              <span className="text-dark">{item.name || item}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedSearches;